import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { NavLink, Link } from "react-router-dom";
// Assets
import LogoIcon from "../../assets/svg/Logo";

const links = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);

  useEffect(() => {
    const handleScroll = () => setY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Wrapper className="flexCenter animate whiteBg" style={y > 100 ? { height: "60px" } : { height: "80px" }}>
      <NavInner className="container flexSpaceCenter">
        <Link className="pointer flexNullCenter" to="/">
          <LogoIcon />
        </Link>
        <UlWrapper className="flexNullCenter">
          {links.map((link) => (
            <li key={link.to} className="semiBold font15 pointer">
              <NavLink
                end={link.to === "/"}
                to={link.to}
                className={({ isActive }) => (isActive ? "active" : "")}
                style={{ padding: "10px 15px" }}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </UlWrapper>
        <UlWrapperRight className="flexNullCenter" />
      </NavInner>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;


